module.exports = __webpack_public_path__ + "static/media/noodle.80f7a5da.jpg";